import { render, staticRenderFns } from "./all_posts.vue?vue&type=template&id=bc446ba0"
import script from "./all_posts.vue?vue&type=script&lang=js"
export * from "./all_posts.vue?vue&type=script&lang=js"
import style0 from "./all_posts.vue?vue&type=style&index=0&id=bc446ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports